import React from 'react';
import { motion } from 'framer-motion';
import { AlertTriangleIcon } from 'lucide-react';
import { PROBLEMS } from '../lib/constants';
// Pain-point / empathy section.
export function ProblemsSection() {
  return <section className="px-5 py-8" data-id="element-134">
      <div className="mx-auto max-w-md" data-id="element-135">
        <h2 className="text-center font-[Montserrat] text-xl font-extrabold leading-snug text-white" data-id="element-136">
          El examen del PER es complicado y sabemos que esto puede llegar a
          pasarte más de una vez
        </h2>

        <ul className="mt-6 space-y-3" data-id="element-137">
          {PROBLEMS.map((p, i) => <motion.li key={i} initial={{
          opacity: 0,
          x: -16
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          amount: 0.4
        }} transition={{
          duration: 0.35,
          delay: i * 0.05
        }} className="flex items-start gap-3 rounded-xl border border-red-400/20 bg-red-950/30 p-3" data-id="element-138">
              <AlertTriangleIcon className="mt-0.5 h-5 w-5 flex-none text-red-400" aria-hidden="true" data-id="element-139" />
              <span className="text-sm leading-relaxed text-blue-50" data-id="element-140">{p}</span>
            </motion.li>)}
        </ul>
      </div>
    </section>;
}